import { useClientView } from '~/hooks/useClientView';
import { nativeUserIdOf } from '../ContactsDashboardRow.utils';
export const useOpenContactClientPortal = ()=>{
    const { startClientView } = useClientView();
    return (contact, customerId)=>{
        const viewUserId = nativeUserIdOf(contact);
        if (viewUserId == null) return;
        void startClientView(customerId, viewUserId);
    };
};
